module.exports = __webpack_public_path__ + "static/media/11_.c820454a.png";